import script from "./LogoList.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoList.vue?vue&type=script&setup=true&lang=js"

import "./LogoList.vue?vue&type=style&index=0&id=6e8d18a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8d18a0"]])

export default __exports__